enum ScheduleBoardView {
	WEEKLY_VIEW = 'weeklyView',
	DAILY_VIEW = 'dailyView',
	MECHANIC_VIEW = 'mechanicView'
}

export default ScheduleBoardView;
